module.exports = __webpack_public_path__ + "media/images/home/about_us/AV0_5469-c5a4e7d4e9435ea6a1ded5e489d3183c.jpg";